import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, Output, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-accordion',
  templateUrl: './lib-accordion.component.html',
  styleUrls: ['./lib-accordion.component.scss'],
  animations: [
    trigger('rotatedState', [
      state('true', style({ transform: 'rotate(0)' })),
      state('false', style({ transform: 'rotate(-180deg)', top: '0px', position: 'relative' })),
      transition('false => true', animate('200ms ease-out')),
      transition('true => false', animate('200ms ease-in')),
    ]),
    trigger('accordionBody', [
      state('false', style({ height: 0 })),
      state('true', style({ height: '*' })),
      transition('true => false', animate('200ms ease-in')),
      transition('false => true', animate('200ms ease-out')),
    ]),
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibAccordionComponent {
  @Input() isOpen? = false;
  @Input() isNested? = false;
  @Input() showChevron? = true;
  @Input() isSubAccordion? = false;
  @Input() isLoading? = false;
  @Input() centeredIcon? = false;
  @Input() showOldSpinner: boolean = true;
  @Output() accordionClicked: EventEmitter<boolean> = new EventEmitter();

  toggleAccordion(): void {
    if (!this.showChevron) {
      return;
    }
    this.isOpen = !this.isOpen;
    this.accordionClicked.emit(this.isOpen);
  }
}
